"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Region = void 0;
var Region;
(function (Region) {
  Region["NORTH_AMERICA"] = "North America";
  Region["LATAM"] = "Latam";
  Region["NORDIC"] = "Nordic";
  Region["REST_OF_THE_WORLD"] = "Rest of the world";
})(Region || (exports.Region = Region = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3JlZ2lvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLE1BS1g7QUFMRCxXQUFZLE1BQU07SUFDZCx5Q0FBK0IsQ0FBQTtJQUMvQix5QkFBZSxDQUFBO0lBQ2YsMkJBQWlCLENBQUE7SUFDakIsaURBQXFDLENBQUE7QUFDekMsQ0FBQyxFQUxXLE1BQU0sc0JBQU4sTUFBTSxRQUtqQiJ9